import { render } from "./UiModal.vue?vue&type=template&id=8557453c&ts=true"
import script from "./UiModal.vue?vue&type=script&lang=ts"
export * from "./UiModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__